import { IProduct } from './product';

export interface IProductPriceProposal {
  _id?: string;
  productId: string;
  userId: string;
  customPrice: number;
  product?: IProduct;
  status: EStatusPriceProposal;
}

export enum EStatusPriceProposal {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface IFilterProductPriceProposal {
  userId?: string;
}
